
@if(sessionService.activeSessionCheck()) {
  <button mat-raised-button [matMenuTriggerFor]="user_menu"
    aria-label="Open user menu"
    aria-haspopup="true"
    aria-expanded="false"
    id="user-menu-button"
    i18n-aria-label>
    <mat-icon [ngClass]="{
        'status-pending':  idvStatus === 'PENDING',
        'status-failed':   idvStatus === 'FAILED',
        'status-verified': idvStatus === 'SUCCESS',
        'status-retry':    idvStatus === 'RETRY',
        'status-default':  idvStatus === 'NONE',
        'status-global':   true
      }" style="transform: scale(1.2); margin-left: auto; margin-right: auto;">
        account_circle
    </mat-icon>

  </button>
  <mat-menu #user_menu="matMenu">
    <!-- Log out button -->
    <button mat-menu-item (click)="logout()">
      <mat-icon>exit_to_app</mat-icon>
      <span i18n>Logout</span>
    </button>

    <!-- Verification Status -->
    @if(showIDVstatus()) {
      @switch (idvStatus) {
        @case ("PENDING") {
          <button mat-menu-item class="button-unclickable">
            <mat-icon style="color: orange;">av_timer</mat-icon>
            <span i18n>Verification Pending</span>
          </button>
        }
        @case ("SUCCESS") {
          <button mat-menu-item class="button-unclickable">
            <mat-icon style="color: green;">verified_user</mat-icon>
            <span i18n>Identity Verified</span>
          </button>
        }
        @case ("RETRY") {
          <button mat-menu-item class="button-unclickable">
            <mat-icon style="color: blue;">repeat</mat-icon>
            <span i18n>Retry Verification</span>
          </button>
        }
        @case ("FAILED") {
          <button mat-menu-item class="button-unclickable">
            <mat-icon style="color: #AD0000;">report</mat-icon>
            <span i18n>Verification Failed</span>
          </button>  
        }
        @default {
          <button mat-menu-item class="button-unclickable">
            <mat-icon style="color: gray;">stars</mat-icon>
            <span i18n>No Verifications</span>
          </button>
        }
      }
    }

    <!-- Change Paassword button -->
    @if(showChangePassword()) {
      <button mat-menu-item (click)="changePassword()">
        <mat-icon>swap_horiz</mat-icon>
        <span i18n>Change Password</span>
      </button>
    }

    <!-- Select MFA Method Button -->
    @if(showChangeMfa()) {
      <button mat-menu-item (click)="changeMFA()">
        <mat-icon>security</mat-icon>
        <span i18n>2-Factor Authentication</span>
      </button>
    }

    <!-- View Receipt Code button -->
    @if(electorDataService.receiptCode()) {
      <button mat-menu-item (click)="receiptCode()">
        <mat-icon>receipt</mat-icon>
        <span i18n>Receipt Code</span>
      </button>
    }

    @if(showRefreshDashboard()) {
      <button mat-menu-item [ngClass]="{'button-container-expired': refreshLocked()}" [disabled]="refreshLocked()" (click)="refresh()">
        <mat-icon [ngClass]="{'expired-text-color': refreshLocked()}">autorenew</mat-icon>
        <span [ngClass]="{'expired-text-color': refreshLocked()}" i18n>Refresh Dashboard</span>
      </button>
    }

  </mat-menu>
}